import { jwtDecode } from 'jwt-decode';
import React, { Component } from "react";
import {
  ArrayField,
  ArrayInput,
  AutocompleteInput,
  BooleanField,
  BooleanInput,
  Button,
  CheckboxGroupInput,
  ChipField,
  Datagrid,
  DateField,
  DateInput,
  EditButton,
  EmailField,
  FileField,
  FileInput,
  FormDataConsumer,
  FunctionField,
  ImageField,
  ImageInput,
  List,
  NumberField,
  NumberInput,
  Pagination,
  PasswordInput,
  RadioButtonGroupInput,
  ReferenceArrayField,
  ReferenceArrayInput,
  ReferenceField,
  ReferenceInput,
  ReferenceManyField,
  required,
  SelectArrayInput,
  SelectField,
  SelectInput,
  SimpleForm,
  SimpleFormIterator,
  SingleFieldList,
  TextField,
  TextInput,
  TranslatableInputs,
  UrlField,
  WithRecord
} from "react-admin";
import {
  TimeInput,
} from "../components/inputs/DateTimePicker";
import TimeField from "./TimeField";
import { DateTimeInput } from '@react-admin/ra-form-layout';

import { MarkdownInput } from '@react-admin/ra-markdown';
import { Link } from "react-router-dom";
import { generateSQLRoleFields, roles } from '../../config';

import IFrameField from "../components/IFrameField";

import alasql from "alasql";
import { useFormContext } from "react-hook-form";
import { factoryMapHook } from "../../factoryMapHook";
import { ColorField, ColorInput } from "../ColorInput/ColorInput";
import AddMoreButton from "./ui/AddMoreButton";
import DefaultListGrid from "./ui/DefaultListGrid";
import PostBulkActionButtons from "./ui/PostBulkActionButtons";
import TabedListGrid from "./ui/TabedListGrid";

import {
  CreateInDialogButton
} from '@react-admin/ra-form-layout';
import { MarkdownField } from "@react-admin/ra-markdown";
import { generateInputField } from "./factory";
import moment from "moment-timezone";


import {
ReferenceFieldInputSearchNewWatchxxx
} from "../../components/custom/Aman/OdsSearch/vehicle";



export const factoryMap = (
  f,
  index,
  input_widget,
  component,
  className,
  record,
  id,
  locale
) => {
  const { field_meta, source_name, css_class, full_width, is_required, disabled, watched_column } = f;

  let choices = {};
  let meta, reference, referancesRourceName, referancesSource;



  switch (input_widget) {
    case "password_input":
      component = passwordInput(component, source_name, index, css_class);
      break;
    case "password_input_change":
      component = passwordInputChange(component, source_name, index, css_class);
      break;
    case "autocompleate_input":
      component = autoCompleteInput(component, index, source_name, css_class);
      break;
    case "text_input":
      component = textInput(
        component,
        source_name,
        index,
        css_class,
        is_required
      );
      break;
    case "color_input":
      component = colorInput(
        component,
        source_name,
        index,
        css_class,
        is_required
      );
      break;
    case "text_field":
      component = textField(
        component,
        source_name,
        index,
        css_class,
        className
      );
      break;
    case "text_field_disabled":
      component = textFieldDisabled(
        component,
        source_name,
        index,
        css_class,
        className
      );
      break;
    case "time_field":
      component = timeField(
        component,
        source_name,
        index,
        css_class,
        className
      );
      break;
    case "color_field":
      component = colorField(
        component,
        source_name,
        index,
        css_class,
        className
      );
      break;
    case "long_text_input":
      component = longTextInput(
        component,
        source_name,
        index,
        css_class,
        is_required,
        full_width
      );
      break;
    case "json_input":
      component = jsonInput(component, source_name, index, css_class);
      break;
    case "boolean_input":
      component = booleanInput(component, source_name, index, css_class);
      break;
    case "select_input":
      ({ choices, component } = selectInput(
        choices,
        field_meta,
        component,
        source_name,
        index,
        css_class,
        is_required
      ));
      break;
    case "select_input_multi":
      ({ choices, component } = selectInputMulti(
        choices,
        field_meta,
        component,
        source_name,
        index,
        css_class,
        is_required
      ));
      break;
    case "date_time_input":
      component = dateTimeInput(component, source_name, index, css_class, is_required, full_width,field_meta);
      break;
          case "date_time_input_watch":

              component= <ReferenceFieldInputSearchNewWatchxxx
                          source_name={source_name}
                          meta={meta}
                          field_meta={field_meta}
                          index={index}
                          css_class={css_class}
                          is_required={is_required}
          
                        />;

  
      break;

 
     // component = dateTimeInputWatch(component, source_name, index, css_class, is_required, full_width,field_meta);
      break;

    case "date_time_field":
      component = dateTimeField(component, source_name, index, css_class);
      break;
    case "time_input":
      component = timeInput(component, source_name, index, css_class);
      break;
    case "pdf_input":
      component = pdfInput(component, source_name, index, css_class);
      break;
    case "image_input":
      component = imageInput(
        component,
        source_name,
        index,
        css_class,
        is_required,
        full_width
      );
      break;
    case "disabled_input":
      component = disabledInput(component, source_name, index, css_class);
      break;
    case "file_input":
      component = fileInput(component, source_name, index, css_class,is_required);
      break;
    case "number_input":
      component = numberInput(
        component,
        source_name,
        index,
        css_class,
        is_required
      );
      break;
    case "radio_button_group_input":
      ({ choices, component } = radioButtonGroupInput(
        choices,
        field_meta,
        component,
        source_name,
        index,
        css_class
      ));
      break;
    case "rich_text_input":
      component = richTextInput(component, source_name, index, css_class);
      break;
    case "date_hijry":
      ({ meta, reference, referancesRourceName, referancesSource, component } =
        date_hijry(
          meta,
          field_meta,
          reference,
          referancesRourceName,
          referancesSource,
          component,
          index,
          css_class
        ));
      break;
    case "referance_field_input":
      ({ meta, reference, referancesRourceName, referancesSource, component } =
        referenceFieldInput(
          meta,
          field_meta,
          reference,
          referancesRourceName,
          referancesSource,
          component,
          index,
          css_class,
          is_required
        ));
      break;
    case "referance_field_filter_input":
      ({ meta, reference, referancesRourceName, referancesSource, component } =
        referenceFieldFilterInput(
          meta,
          field_meta,
          reference,
          referancesRourceName,
          referancesSource,
          component,
          index,
          css_class,
          full_width
        ));
      break;
    case "referance_depenancy_input":
      ({ meta, reference, referancesRourceName, referancesSource, component } =
        referenceFieldDepenancyInput(
          source_name,
          meta,
          field_meta,
          reference,
          referancesRourceName,
          referancesSource,
          component,
          index,
          css_class,
          full_width,
          is_required
        ));
      break;
    case "referance_depenancy_input_search":
      ({ meta, reference, referancesRourceName, referancesSource, component } =
        referenceFieldDepenancyInputSearch(
          meta,
          field_meta,
          reference,
          referancesRourceName,
          referancesSource,
          component,
          index,
          css_class,
          full_width,
          is_required,
          source_name
        ));
      break;
    case "referance_depenancy_input_search_multi":
      ({ meta, reference, referancesRourceName, referancesSource, component } =
        referenceFieldDepenancyInputSearchMulti(
          meta,
          field_meta,
          reference,
          referancesRourceName,
          referancesSource,
          component,
          index,
          css_class,
          full_width,
          is_required,
          source_name
        ));
      break;
    case "multi_array_input":
      ({ meta, reference, referancesRourceName, referancesSource, component } =
        multiArrayInput(
          meta,
          field_meta,
          reference,
          referancesRourceName,
          referancesSource,
          component,
          source_name,
          index,
          css_class
        ));
      break;
    case "check_box_group_input":
      ({ choices, component } = checkBoxGroupInput(
        choices,
        field_meta,
        component,
        source_name,
        index,
        css_class
      ));
      break;
    case "referance_array_field_input":
      ({ meta, reference, referancesRourceName, referancesSource, component } =
        referenceArrayFieldInput(
          meta,
          field_meta,
          reference,
          referancesRourceName,
          referancesSource,
          component,
          index,
          full_width,
          css_class
        ));
      break;
    case "referance_array_field_input_dependancy":
      ({ meta, reference, referancesRourceName, referancesSource, component } =
        referenceArrayFieldInputDepandancy(
          meta,
          field_meta,
          reference,
          referancesRourceName,
          referancesSource,
          component,
          index,
          full_width,
          css_class
        ));
      break;
    case "referance_array_field":
      ({ meta, reference, referancesRourceName, referancesSource, component } =
        referenceArrayField(
          meta,
          field_meta,
          reference,
          referancesRourceName,
          referancesSource,
          component,
          index,
          css_class,
          source_name
        ));
      break;
    case "multi_array_field":
      ({ meta, reference, referancesRourceName, referancesSource, component } =
        multiArrayField(
          meta,
          field_meta,
          source_name,
          reference,
          referancesRourceName,
          referancesSource,
          component,
          index,
          css_class
        ));
      break;
    case "date_input":
      component = dateInput(
        component,
        source_name,
        index,
        css_class,
        full_width,
        disabled
      );
      break;

    case "reference_text_alt":
      ({ meta, reference, referancesRourceName, referancesSource, component } =
        referenceTextDep(
          meta,
          field_meta,
          reference,
          referancesRourceName,
          referancesSource,
          component,
          index,
          css_class,
          className
        ));
      break;
    case "file_field":
      component = fileField(component, source_name, index, field_meta);
      break;
    case "email_field":
      component = emailField(
        component,
        source_name,
        index,
        css_class,
        className
      );
      break;
    case "image_field_":
      component = imageField_(
        component,
        source_name,
        index,
        css_class,
        className
      );
      break;
    case "number_field":
      component = numberField(
        component,
        source_name,
        index,
        css_class,
        className
      );
      break;
    case "iframe_field":
      component = iframeField(component, source_name, index);
      break;
    case "select_field":
      ({ choices, component } = selectField(
        choices,
        field_meta,
        component,
        source_name,
        index,
        css_class,
        className
      ));
      break;
    case "boolean_field":
      component = booleanField(
        component,
        source_name,
        index,
        css_class,
        className
      );
      break;
    case "richtext_field":
    case "json_field":
      component = richTextField(component, source_name, index);
      break;
    case "url_field":
      component = urlField(component, source_name, index, css_class, className);
      break;
    case "reference_text":
      ({ meta, reference, referancesRourceName, referancesSource, component } =
        referenceText(
          meta,
          field_meta,
          reference,
          referancesRourceName,
          referancesSource,
          component,
          index,
          css_class,
          className
        ));
      break;
    case "reference_many_field":
      component = referenceManyField(field_meta, component, index, record);
      break;
    case "reference_resource":
      component = referenceResource(
        field_meta,
        component,
        index,
        record,
        f,
        id
      );
      break;
    case "reference_resource_show":
      component = referenceResourceShow(
        field_meta,
        component,
        index,
        record,
        f,
        id
      );
      break;
    case "pdf_field":
      component = pdfField(component, index, source_name);
      break;
    case "image_field":
      component = imageField(
        component,
        index,
        source_name,
        css_class,
        className
      );
      break;
    case "date_field":
      component = dateField(
        component,
        source_name,
        index,
        css_class,
        className
      );
      break;
    case "long_text_field":
      component = longTextField(
        component,
        source_name,
        index,
        css_class,
        full_width
      );
      break;
    case "translatable_text_input":
      component = TranslatableTextInput(
        component,
        source_name,
        index,
        css_class,
        is_required
      );
      break;
    case "translatable_text_search":
      component = TranslatableTextSearch(
        component,
        source_name,
        index,
        css_class,
        is_required,
        locale
      );
      break;
    case "translatable_text_field":
      component = TranslatableTextField(
        component,
        source_name,
        index,
        css_class,
        className,
        locale
      );
      break;
    default:
      component = factoryMapHook(
        f,
        index,
        input_widget,
        component,
        className,
        record
      );
      break;
  }
  
  return component;
};

const TestA = (props) => {
  const form = useFormContext();
  const { resource, source, source_name, index, css_class } = props;
  form.change(source_name, "");
  const disabled = true;
  return (
    <PasswordInput
      label="كلمة المرور"
      source={source_name}
      key={index}
      className={` ${css_class}  `}
    />
  );
};

class AutocompleteInputFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      choicesObject: [],
    };
  }

  async componentDidMount() {
    const { resource, source } = this.props;
    let _choicesObject = [];
    let GRAPHQL_ENDPOINT = localStorage.getItem("GRAPHQL_ENDPOINT");
    let res = await fetch(`${GRAPHQL_ENDPOINT}/v1/graphql`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-hasura-admin-secret": "qiddiya",
      },
      body: JSON.stringify({
        query: `{ list:${resource}(distinct_on:${source}, where:{${source}:{_is_null: false}}){ value:${source} } }`,
      }),
    });
    let json = await res.json();
    _choicesObject = json.data.list.map((i) => ({
      id: i.value,
      name: i.value,
    }));

    this.setState({
      loading: false,
      choicesObject: _choicesObject,
    });
  }

  render() {
    const { resource, source } = this.props;
    const { choicesObject } = this.state;
    return (
      <AutocompleteInput
        shouldRenderSuggestions={(val) => {
          return val.trim().length > 1;
        }}
        source={source}
        resource={resource}
        choices={choicesObject}
        {...this.props}
      />
    );
  }
}

const AddButton = ({
  record,
  reference,
  source,
  target,
  index,
  origin,
  tab,
}) => {
  return (
    <Button
      variant="raised"
      component={Link}
      key={index}
      to={{
        pathname: `/${reference}/create`,
        state: {
          record: { [target]: record.id },
          id: record.id,
          reference,
          source,
          target,
          index,
          origin,
          tab,
        },
      }}
      label={"إضافة"}
    ></Button>
  );
};

function autoCompleteInput(component, index, source_name, css_class) {
  component = (
    <AutocompleteInputFilter
      key={index}
      source={source_name}
      className={` ${css_class}  `}
    />
  );
  return component;
}

function pdfField(component, index, source_name) {
  component = (
    <Field
      key={index}
      name={source_name}
      source={source_name}
      component={IFrameField}
    />
  );
  return component;
}

function referenceManyField(field_meta, component, index, record) {

  const metaData = JSON.parse(field_meta);

  component = [
    <ReferenceManyField
      addLabel={false}
      reference={metaData.reference}
      key={index}
      target={metaData.target}
    >
      <Datagrid>
        {metaData.fields.map((field) => (
          <TextField source={field} key={field} />
        ))}
        <EditButton />
      </Datagrid>
    </ReferenceManyField>,
    <AddButton index={index} {...metaData} record={record} />,
  ];
  return component;
}

function referenceTabsResource(field_meta, component, index, record) {
  const metaData = JSON.parse(field_meta);
  const role = localStorage.getItem("role");
  let resource = metaData.reference;
  let resourcesFields = alasql(
    `
        select watched_column,source_name,field_widget_type, field_meta, css_class from resources 
        WHERE 
        resource_name ='${resource}' AND is_list_field =true 
        AND ( role_${role}='read' OR role_${role}='write' ) 
        `
  );
  component = [
    <ReferenceManyField
      addLabel={false}
      reference={metaData.reference}
      target={metaData.target}
    >
      <TabedListGrid
        resourcePermistions={[]}
        resourcesFields={resourcesFields}
      />
    </ReferenceManyField>,
  ];
  return component;
}

function referenceResource(field_meta, component, index, record, f, id) {
  const metaData = JSON.parse(field_meta);
  const role = localStorage.getItem("role");
  let resource = metaData.reference;
  let resourcesFields = alasql(
    `
        select watched_column,source_name,field_widget_type, field_meta, css_class from resources 
        WHERE 
        resource_name ='${resource}' AND is_list_field =true  and is_expand_field=true 
        AND ( role_${role}='read' OR role_${role}='write' ) 
        `
  );
  let resourcesFieldsInput = alasql(
    `select distinct write_group as tab  from resources where resource_name ='${resource}'  and   is_inline=true `
  ).map(({ tab }) =>
    alasql(`select  watched_column,grid_class,grid_xs,grid_sm,is_require_separator,is_require_label,label_text,source_name, edit_input_widget_type as input_widget_type, field_meta , annotation, css_class, edit_css_class, full_width,is_required  from resources where write_group ="${tab}" and resource_name ='${resource}'  and is_edit_field =true
  AND ( role_${role}='write' ) and   is_inline=true `)
  );
  let tabs = alasql(
    `select distinct write_group as tab  from resources where resource_name ='${resource}'  and   is_inline=true   and   is_edit_field =true and  role_${role}='write' `
  ).map(({ tab }) => tab);
  const sqlRoleFields = generateSQLRoleFields(['show', 'edit', 'delete'], roles);
  let resourcePermistions = alasql(
    `select is_expand,expand_resource, expand_source, expand_destination,list_is_tab,list_is_calendar,list_tabs,list_tab_filter,list_tab_filter_value,resource_name,inline_update,inline_create, 
    ${sqlRoleFields}    from resource_permistions  where resource_name ='${resource}' `
  );
  if (resourcePermistions && resourcePermistions[0].list_is_tab) {
    resourcePermistions[0].list_tab_filter_value = parseInt(
      resourcePermistions[0].list_tab_filter_value
    );
    component = [
      <FormDataConsumer key={index} className={`   `}>
        {({ formData, ...rest }) => (
          <>
            <ReferenceManyField
              addLabel={false}
              fullWidth
              reference={metaData.reference}
              target={metaData.target}
              perPage={5000}
              {...rest}
            >
              <TabedListGrid
                fullWidth
                resourcePermistions={resourcePermistions[0]}
                resourcesFields={resourcesFields}
              />
            </ReferenceManyField>
            <AddMoreButton
              id={id}
              resource={metaData.reference}
              target={metaData.target}
              from={metaData.backTo}
              tab={metaData.tab}
            />
          </>
        )}
      </FormDataConsumer>,
    ];
  } else {
    component = [
      <ReferenceManyField
        addLabel={false}
        reference={metaData.reference}
        target={metaData.target}
        pagination={<Pagination />}
      >
        <WithRecord
          render={record => (
            <CreateInDialogButton
              record={{ course_id: record.id }}
              fullWidth
              maxWidth="sm"
              key={`dialog-${index}`}
            >
              <SimpleForm key={`form-${index}`} defaultValues={{ status: 'pending' }}>
                {tabs.map((t, indexextra) => {
                  return (
                    <React.Fragment key={`tab-${indexextra}`}>
                      {resourcesFieldsInput[indexextra] && resourcesFieldsInput[indexextra].map((f, indexloop) => {
                        // Create unique key using all indices + source_name
                        const uniqueKey = `input-${index}-${indexextra}-${indexloop}-${f.source_name || indexloop}`;
                        return generateInputField(f, uniqueKey, id);
                      })}
                    </React.Fragment>
                  );
                })}
              </SimpleForm>
            </CreateInDialogButton>
          )}
        />
        <DefaultListGrid
          key={index}
          sx={{
            width: '100%',
            '& .column-comment': {
              maxWidth: '20em',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            },
          }}
          resourcePermistions={resourcePermistions[0]}
          resourcesFields={resourcesFields}
        />
      </ReferenceManyField>,
    ];
  }
  return component;
}

class TabsListGridWithActions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stateColumn: null,
      stateValue: 0,
    };
  }
  onTabChange = (Column, Value) => {
    const { stateColumn, stateValue } = this.state;
    if (stateColumn != Column || Value != stateValue) {
      this.setState({
        stateColumn: Column,
        stateValue: Value,
      });
    }
  };

  render() {
    const { metaData, resource, resourcePermistions, resourcesFields, rowId } = this.props;
    const { stateColumn, stateValue } = this.state;
    return (
      <ReferenceManyField
        addLabel={false}
        fullWidth
        reference={metaData.reference}
        filter={{ [metaData.target]: rowId ? rowId : null }}
        target={metaData.target}
        perPage={5000}
        {...this.props}
      >
        <List
          fullWidth
          bulkActionButtons={
            <PostBulkActionButtons
              resource={resource}
              Column={stateColumn}
              Value={stateValue}
            />
          }
          exporter={false}
          filterDefaultValues={{
            [resourcePermistions[0].list_tab_filter]:
              resourcePermistions[0].list_tab_filter_value,
          }}
        >
          <TabedListGrid
            fullWidth
            resourcePermistions={resourcePermistions[0]}
            onTabChange={this.onTabChange}
            resourcesFields={resourcesFields}
          />
        </List>
      </ReferenceManyField>
    );
  }
}

function referenceResourceShow(field_meta, component, index, record, f, id) {
  const metaData = JSON.parse(field_meta);
  const role = localStorage.getItem("role");
  let resource = metaData.reference;
  let resourcesFields = alasql(
    `
        select watched_column,source_name,field_widget_type, field_meta, css_class from resources 
        WHERE 
        resource_name ='${resource}' AND is_list_field =true 
        AND ( role_${role}='read' OR role_${role}='write' ) 
        `
  );
  const sqlRoleFields = generateSQLRoleFields(['show', 'edit', 'delete'], roles);
  let resourcePermistions = alasql(
    `select is_expand,expand_resource, expand_source, expand_destination,list_is_tab,list_is_calendar,list_tabs,list_tab_filter,list_tab_filter_value,resource_name,inline_update,inline_create, 
    ${sqlRoleFields} from resource_permistions  where resource_name ='${resource}' `
  );
  if (resourcePermistions && resourcePermistions[0].list_is_tab) {
    resourcePermistions[0].list_tab_filter_value = parseInt(
      resourcePermistions[0].list_tab_filter_value
    );
    component = [
      <TabsListGridWithActions
        metaData={metaData}
        resource={resource}
        resourcesFields={resourcesFields}
        rowId={id}
        resourcePermistions={resourcePermistions}
      />,
    ];
  } else {
    component = [
      <ReferenceManyField
        reference={metaData.reference}
        target={metaData.target}
        perPage={5000}
      >
        <DefaultListGrid label="" bulkActionButtons={false} resourcesFields={resourcesFields} />
      </ReferenceManyField>,
    ];
  }
  return component;
}

function referenceText(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class,
  className
) {
  meta = field_meta.split(".");
  reference = meta[0];
  referancesRourceName = meta[1];
  referancesSource = meta[2];
  component = (
    <ReferenceField
      link={false}
      source={referancesRourceName}
      reference={reference}
      key={index}
      className={`show-field ${css_class} ${className}`}
    >
      <TextField source={referancesSource} />
    </ReferenceField>
  );
  return { meta, reference, referancesRourceName, referancesSource, component };
}

function referenceTextDep(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class,
  className
) {
  meta = field_meta.split(".");
  reference = meta[5];
  referancesRourceName = meta[6];
  referancesSource = meta[7];
  component = (
    <ReferenceField
      link={false}
      source={referancesRourceName}
      reference={reference}
      key={index}
      className={`show-field ${css_class} ${className}`}
    >
      <TextField source={referancesSource} />
    </ReferenceField>
  );
  return { meta, reference, referancesRourceName, referancesSource, component };
}

function urlField(component, source_name, index, css_class, className) {
  component = (
    <UrlField
      source={source_name}
      key={index}
      className={`show-field ${css_class} ${className}`}
    />
  );
  return component;
}

function richTextField(component, source_name, index) {
  component = <MarkdownField source={source_name} key={index} />;
  return component;
}
function richTextInput(component, source_name, index) {
  component = <MarkdownInput source={source_name} key={index} />;
  return component;
}
function booleanField(component, source_name, index, css_class, className) {
  component = (
    <BooleanField
      source={source_name}
      key={index}
      className={`show-field ${css_class} ${className}`}
    />
  );
  return component;
}
function dateField(component, source_name, index, css_class, className) {
  component = (
    <DateField
      source={source_name}
      key={index}
      className={`show-field ${css_class} ${className}`}
    />
  );
  return component;
}
function selectField(
  choices,
  field_meta,
  component,
  source_name,
  index,
  css_class,
  className
) {
  choices = JSON.parse(field_meta);
  component = (
    <SelectField
      source={source_name}
      choices={choices}
      translateChoice={false}
      key={index}
      className={`show-field ${css_class} ${className}`}
    />
  );
  return { choices, component };
}
function iframeField(component, source_name, index) {
  component = <IFrameField source={source_name} key={index} />;
  return component;
}
function imageField_(component, source_name, index, css_class, className) {
  component = (
    <ImageField
      source={`${source_name}.src`}
      key={index}
      className={`image-field-container ${css_class} ${className}`}
    />
  );
  return component;
}
function imageField(component, index, source_name, css_class, className) {
  component = (
    <Field
      key={index}
      name={source_name}
      source={source_name}
      component={IFrameField}
      className={`show-field ${css_class} ${className}`}
    />
  );
  return component;
}
function numberField(component, source_name, index, css_class, className) {
  component = (
    <NumberField
      source={source_name}
      key={index}
      className={`show-field ${css_class} ${className}`}
    />
  );
  return component;
}
function fileField(component, source_name, index, field_meta) {
  component = (
    <FileField
      source={field_meta}
      title="اضغط لتحميل المستند  "
      onClick={() => {
        const token = localStorage.getItem("hz-tokenLogin");
        let usersData = jwtDecode(token);
        let object_uuid = "05444944-0000-0000-0000-0b84c1622981";
        fetch(
          `https://archive-api.rafedsa.com/api/rest/views/log?object_type=download_${source_name}&object_uuid=${object_uuid}&user_id=${usersData.sub}&user_name=${usersData.name}`,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              authorization: token ? `Bearer ${token}` : "",
            },
          }
        ).then((r) => {
          //console.log(r);
        });
      }}
    >
      {" "}
    </FileField>
  );
  return component;
}
function emailField(component, source_name, index, css_class, className) {
  component = (
    <EmailField
      source={source_name}
      key={index}
      className={`show-field ${css_class} ${className}`}
    />
  );
  return component;
}
function dateInput(component, source_name, index, css_class, full_width, disabled) {
  component = (
    <DateInput
      source={source_name}
      key={index}
      fullWidth={full_width}
      className="input-field"
      disabled={disabled}
      options={{ format: "yyyy-MM-dd", timeZone: "Asia/Riyadh" }}
    />
  );
  return component;
}



function referenceArrayField(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class,
  source_name
) {
  meta = field_meta.split(".");
  reference = meta[0];
  referancesRourceName = meta[1];
  referancesSource = meta[2];
  component = (
    <ReferenceArrayField
      label={" " + source_name}
      source={referancesRourceName}
      target="id"
      reference={reference}
      key={index}
      className={` ${css_class}  `}
    >
      <SingleFieldList>
        <ChipField source={referancesSource} />
      </SingleFieldList>
    </ReferenceArrayField>
  );
  return { meta, reference, referancesRourceName, referancesSource, component };
}
function multiArrayField(
  meta,
  field_meta,
  source_name,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class
) {
  meta = field_meta.split(".");
  reference = meta[0];
  referancesRourceName = meta[1];
  referancesSource = meta[2];
  component = (
    <ArrayField source={source_name}>
      <Datagrid>
        <ReferenceField
          link={false}
          source="contract_id"
          reference="domain_contracts"
          key={index}
        >
          <TextField source="contract_number" />
        </ReferenceField>
        <ReferenceField
          link={false}
          source="contractor_id"
          reference="domain_contractors"
          key={index}
        >
          <TextField source="name" />
        </ReferenceField>
        <TextField source="allocated" />
        <TextField source="assigned" />
        <ReferenceField
          link={false}
          source="type_id"
          reference="domain_examination_types"
          key={index}
        >
          <TextField source="type" />
        </ReferenceField>
        <ArrayField source="buses">
          <Datagrid>
            <ReferenceField
              link={false}
              source="bus_id"
              reference="bus"
              key={index}
            >
              <TextField source="bus_number" />
            </ReferenceField>
            <TextField source="no_of_rounds" />
            <TextField source="seat_number_first_round" />
            <TextField source="seat_number_second_round" />
          </Datagrid>
        </ArrayField>
      </Datagrid>
    </ArrayField>
  );
  return { meta, reference, referancesRourceName, referancesSource, component };
}
function referenceArrayFieldInput(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  full_width,
  css_class
) {
  meta = field_meta.split(".");
  reference = meta[0];
  referancesRourceName = meta[1];
  referancesSource = meta[2];
  component = (
    <ReferenceArrayInput
      perPage={5000}
      source={referancesRourceName}
      reference={reference}
      key={index}
      fullWidth={full_width}
      className={` ${css_class}  `}
    >
      <SelectArrayInput optionText={referancesSource} />
    </ReferenceArrayInput>
  );
  return { meta, reference, referancesRourceName, referancesSource, component };
}
function referenceArrayFieldInputDepandancy(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class,
  full_width,
  is_required
) {
  meta = field_meta.split(".");
  reference = meta[0];
  referancesRourceName = meta[1];
  referancesSource = meta[2];
  let filterForeignKey = meta[3];
  let filterSearchKeyWordValue = meta[4];
  component = (
    <FormDataConsumer key={index} className={` ${css_class}  `}>
      {({ formData, ...rest }) => (
        <>
          <ReferenceArrayInput
            source={referancesRourceName}
            reference={reference}
            perPage={5000}
            filter={{ [filterForeignKey]: formData[filterSearchKeyWordValue] }}
            {...rest}
          >
            <SelectArrayInput
              optionText={referancesSource}
              validate={is_required ? [required()] : undefined}
            />
          </ReferenceArrayInput>
        </>
      )}
    </FormDataConsumer>
  );
  return { meta, reference, referancesRourceName, referancesSource, component };
}
function checkBoxGroupInput(
  choices,
  field_meta,
  component,
  source_name,
  index,
  css_class
) {
  choices = JSON.parse(field_meta);
  component = (
    <CheckboxGroupInput
      source={source_name}
      key={index}
      choices={choices}
      className={` ${css_class}  `}
    />
  );
  return component;
}
function multiArrayInput(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  source_name,
  index,
  css_class
) {
  meta = field_meta.split(".");
  reference = meta[0];
  referancesRourceName = meta[1];
  referancesSource = meta[2];
  let deepmetaReference = meta[3];
  let deepReferancesRourceName = meta[4];
  let deepmetaReferancesSource = meta[5];
  component = (
    <ArrayInput source={source_name}>
      <SimpleFormIterator>
        <ReferenceInput
          source={referancesRourceName}
          reference={reference}
          key={index}
          className={` ${css_class}  `}
        >
          <SelectInput optionText={referancesSource} />
        </ReferenceInput>
        <BooleanInput
          source="violation_form8"
          key={index}
          defaultValue={true}
          className={` ${css_class}  `}
        />
        <BooleanInput
          source="need_processing"
          key={index}
          defaultValue={true}
          className={` ${css_class}  `}
        />
        <BooleanInput
          source="need_pic_proof"
          key={index}
          defaultValue={true}
          className={` ${css_class}  `}
        />
        <ArrayInput source="answers_settings">
          <SimpleFormIterator>
            <ReferenceInput
              source={deepReferancesRourceName}
              reference={deepmetaReference}
              key={index}
            >
              <SelectInput
                className={` ${css_class}  `}
                optionText={deepmetaReferancesSource}
              />
            </ReferenceInput>
            <NumberInput
              source="timeout_in_days"
              key={index}
              className={` ${css_class}  `}
            />
            <BooleanInput
              source="timeout_enable"
              key={index}
              defaultValue={true}
              className={` ${css_class}  `}
            />
            <BooleanInput
              source="exclude_vehicle"
              key={index}
              defaultValue={true}
              className={` ${css_class}  `}
            />
          </SimpleFormIterator>
        </ArrayInput>
      </SimpleFormIterator>
    </ArrayInput>
  );
  return { meta, reference, referancesRourceName, referancesSource, component };
}
function referenceFieldInput(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class,
  is_required
) {
  meta = field_meta.split(".");
  reference = meta[0];
  referancesRourceName = meta[1];
  referancesSource = meta[2];
  component = (
    <ReferenceInput
      fullWidth
      perPage={5000}
      source={referancesRourceName}
      reference={reference}
      filter={meta[3] ? { [meta[3]]: meta[4] } : undefined}
      key={index}
    >
      <SelectInput
        fullWidth
        className={`${css_class}  `}
        optionText={referancesSource}
        validate={is_required ? [required()] : undefined}
      />
    </ReferenceInput>
  );
  return { meta, reference, referancesRourceName, referancesSource, component };
}
function referenceFieldDepenancyInputSearch(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class,
  full_width, // no longer passed to FormDataConsumer
  is_required,
  source_name
) {
  meta = field_meta.split(".");
  reference = meta[0];
  referancesRourceName = meta[1];
  referancesSource = meta[2];
  let filterForeignKey = meta[3];
  let filterSearchKeyWordValue = meta[4];
  component = (
    <FormDataConsumer key={index} source={source_name} className={` ${css_class}  `}>
      {({ formData, ...rest }) => (
        <>
          <ReferenceInput
            source={source_name}
            reference={reference}
            perPage={50}
            filter={{ [filterForeignKey]: formData[filterSearchKeyWordValue] }}
            {...rest}
          >
            <AutocompleteInput
              filterToQuery={(searchText) => ({
                [referancesSource]: searchText,
              })}
              optionText={referancesSource}
              validate={is_required ? [required()] : undefined}
            />
          </ReferenceInput>
        </>
      )}
    </FormDataConsumer>
  );
  return { meta, reference, referancesRourceName, referancesSource, component };
}
function referenceFieldDepenancyInputSearchMulti(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class,
  full_width, // removed from FormDataConsumer below
  is_required,
  source_name
) {
  meta = field_meta.split(".");
  reference = meta[0];
  referancesRourceName = meta[1];
  referancesSource = meta[2];
  let filterForeignKey = meta[3];
  let filterSearchKeyWordValue = meta[4];
  let filterForeignKey2 = meta[5];
  let filterSearchKeyWordValue2 = meta[6];
  component = (
    <FormDataConsumer key={index} source={source_name} className={` ${css_class}  `}>
      {({ formData, ...rest }) => (
        <>
          <ReferenceInput
            source={source_name}
            reference={reference}
            perPage={50}
            filter={{
              [filterForeignKey2]: formData[filterSearchKeyWordValue2],
              [filterForeignKey]: formData[filterSearchKeyWordValue],
            }}
            {...rest}
          >
            <AutocompleteInput
              filterToQuery={(searchText) => ({
                [referancesSource]: searchText,
              })}
              optionText={referancesSource}
              validate={is_required ? [required()] : undefined}
            />
          </ReferenceInput>
        </>
      )}
    </FormDataConsumer>
  );
  return { meta, reference, referancesRourceName, referancesSource, component };
}
function referenceFieldDepenancyInput(
  source_name,
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class,
  full_width, // removed from FormDataConsumer below
  is_required
) {
  meta = field_meta.split(".");
  reference = meta[0];
  referancesRourceName = meta[1];
  referancesSource = meta[2];
  let filterForeignKey = meta[3];
  let filterSearchKeyWordValue = meta[4];
  component = (
    <FormDataConsumer key={index} source={source_name} className={` ${css_class}  `}>
      {({ formData, ...rest }) => (
        <>
          <ReferenceInput
            source={source_name}
            reference={reference}
            perPage={5000}
            filter={{ [filterForeignKey]: formData[filterSearchKeyWordValue] }}
            {...rest}
          >
            <SelectInput
              optionText={referancesSource}
              validate={is_required ? [required()] : undefined}
            />
          </ReferenceInput>
        </>
      )}
    </FormDataConsumer>
  );
  return { meta, reference, referancesRourceName, referancesSource, component };
}
function referenceFieldFilterInput(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class,
  full_width // removed from FormDataConsumer below
) {
  meta = field_meta.split(".");
  reference = meta[0];
  referancesRourceName = meta[1];
  referancesSource = meta[2];
  let filterForeignKey = meta[3];
  let filterSearchKeyWordValue = meta[4];
  component = (
    <FormDataConsumer>
      {({ formData, ...rest }) => (
        <>
          <ReferenceArrayInput
            source={referancesRourceName}
            reference={reference}
            key={index}
            perPage={5000}
            className={` ${css_class}  `}
            filter={{ [filterForeignKey]: formData[filterSearchKeyWordValue] }}
            {...rest}
          >
            <SelectArrayInput optionText={referancesSource} />
          </ReferenceArrayInput>
        </>
      )}
    </FormDataConsumer>
  );
  return { meta, reference, referancesRourceName, referancesSource, component };
}
function date_hijry(
  meta,
  field_meta,
  source_name,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class
) {
  meta = field_meta.split(".");
  source_name = meta[0];
  referancesRourceName = meta[1];
  referancesSource = meta[2];
  component = (
    <FunctionField
      source={source_name}
      render={(record) =>
        `${record[source_name]}-${record[referancesRourceName]}-${record[referancesSource]}`
      }
      key={index}
      className={` ${css_class}  `}
    />
  );
  return {
    meta,
    source_name,
    referancesRourceName,
    referancesSource,
    component,
  };
}
function radioButtonGroupInput(
  choices,
  field_meta,
  component,
  source_name,
  index,
  css_class
) {
  choices = JSON.parse(field_meta);
  component = (
    <RadioButtonGroupInput
      source={source_name}
      key={index}
      choices={choices}
      className={` ${css_class}  `}
    />
  );
  return { choices, component };
}
function numberInput(component, source_name, index, css_class, is_required) {
  component = (
    <NumberInput
      source={source_name}
      key={index}
      validate={is_required ? [required()] : undefined}
      className={` ${css_class}  `}
    />
  );
  return component;
}
function fileInput(component, source_name, index, css_class, is_required) {
  component = (
    <FileInput source={source_name} key={index} className={` ${css_class}  `} validate={is_required ? [required()] : undefined}>
      <UrlField source="src" />
    </FileInput>
  );
  return component;
}
function disabledInput(component, source_name, index, css_class) {
  component = (
    <TextInput
      source={source_name}
      key={index}
      disabled
      className={` ${css_class}  `}
    />
  );
  return component;
}
function imageInput(
  component,
  source_name,
  index,
  css_class,
  is_required,
  full_width
) {
  component = (
    <ImageInput
      source={source_name}
      fullWidth={full_width}
      validate={is_required ? [required()] : undefined}
      accept="image/*"
      key={index}
      className={` ${css_class}  `}
    >
      <ImageField source="src" />
    </ImageInput>
  );
  return component;
}
function pdfInput(component, source_name, index, css_class) {
  component = (
    <FileInput
      source={source_name}
      accept="application/pdf"
      key={index}
      className={` ${css_class}  `}
    >
      <UrlField source="src" />
    </FileInput>
  );
  return component;
}
function dateTimeInput(component, source_name, index, css_class, is_required, full_width,field_meta) {
  let metaData = {};
  if (field_meta) {
    try {
      metaData = JSON.parse(field_meta);
    } catch (error) {
      console.error("Invalid JSON in field_meta:", error);
    }
  }
  // Helper function to handle date parsing
  const parseDate = (dateString) => {
    if (!dateString) return undefined;
    if (dateString.toLowerCase() === "today") return moment().startOf('day').toDate();
    if (dateString.toLowerCase() === "yesterday") return moment().subtract(1, 'days').startOf('day').toDate();
    if (dateString.toLowerCase() === "tomorrow") return moment().add(1, 'days').startOf('day').toDate();
    return moment(dateString, "YYYY-MM-DD", true).isValid() ? moment(dateString).toDate() : undefined;
  };

  const minDate = parseDate(metaData.minDate);
  const maxDate = parseDate(metaData.maxDate);
  component = (
    <DateTimeInput
      validate={is_required ? [required()] : undefined}
      variant="outlined"
      source={source_name}
      key={index}
      className={` ${css_class}  `}
      minDate={minDate}
      maxDate={maxDate}
   
    />
  );
  return component;
}

function dateTimeInputWatch(component, source_name, index, css_class, is_required, full_width,field_meta) {

 

  let metaData = {};
  if (field_meta) {
    try {
      metaData = JSON.parse(field_meta);
    } catch (error) {
      console.error("Invalid JSON in field_meta:", error);
    }
  }
  // Helper function to handle date parsing
  const parseDate = (dateString) => {
    if (!dateString) return undefined;
    if (dateString.toLowerCase() === "today") return moment().startOf('day').toDate();
    if (dateString.toLowerCase() === "yesterday") return moment().subtract(1, 'days').startOf('day').toDate();
    if (dateString.toLowerCase() === "tomorrow") return moment().add(1, 'days').startOf('day').toDate();
    return moment(dateString, "YYYY-MM-DD", true).isValid() ? moment(dateString).toDate() : undefined;
  };

  const minDate = parseDate(metaData.minDate);
  const maxDate = parseDate(metaData.maxDate);
  component = (
    <DateTimeInput
      validate={is_required ? [required()] : undefined}
      variant="outlined"
      source={source_name}
      key={index}
      className={` ${css_class}  `}
      minDate={minDate}
      maxDate={maxDate}
    //  readOnly={disabled} // Use the disabled state from the hook
   
    />
  );
  return component;
}
function dateTimeField(component, source_name, index, css_class) {
  component = (
    <DateField
      source={source_name}
      showTime
    />
  );
  return component;
}
function timeInput(component, source_name, index, css_class) {
  component = (
    <TimeInput
      type="time"
      source={source_name}
      key={index}
      className={` ${css_class}  `}
      options={{ format: "HH:mm" }}
    />
  );
  return component;
}
function selectInput(
  choices,
  field_meta,
  component,
  source_name,
  index,
  css_class,
  is_required
) {
  choices = JSON.parse(field_meta);
  component = (
<AutocompleteInput
  source={source_name}
  fullWidth
  key={index}
  validate={is_required ? [required()] : undefined}
  choices={choices}
  className={` ${css_class} `}
/>
  );
  return { choices, component };
}
function selectInputMulti(
  choices,
  field_meta,
  component,
  source_name,
  index,
  css_class,
  is_required
) {
  choices = JSON.parse(field_meta);
  component = (
<SelectArrayInput
  source={source_name}
  fullWidth
  key={index}
  validate={is_required ? [required()] : undefined}
  choices={choices}
  className={` ${css_class} `}
/>
  );
  return { choices, component };
}
function booleanInput(component, source_name, index, css_class) {
  component = (
    <BooleanInput
      source={source_name}
      key={index}
      defaultValue={false}
      className={` ${css_class}  `}
    />
  );
  return component;
}
function jsonInput(component, source_name, index, css_class) {
  component = (
    <TextInput
      multiline
      source={source_name}
      key={index}
      className={` ${css_class}  `}
    />
  );
  return component;
}
function passwordInput(component, source_name, index, css_class) {
  component = (
    <PasswordInput
      source={source_name}
      key={index}
      className={` ${css_class}  `}
    />
  );
  return component;
}
function passwordInputChange(component, source_name, index, css_class) {
  let disabled = true;
  component = [
    <TestA source_name={source_name} index={index} css_class={css_class} />,
  ];
  return component;
}
function textInput(component, source_name, index, css_class, is_required) {
  component = (
    <TextInput
      fullWidth={true}
      resettable
      validate={is_required ? [required()] : undefined}
      source={source_name}
      key={index}
    />
  );
  return component;
}
function colorInput(component, source_name, index, css_class, is_required) {
  component = (
    <ColorInput
      validate={is_required ? [required()] : undefined}
      source={source_name}
      key={index}
      className={` ${css_class}  `}
    />
  );
  return component;
}
function textField(component, source_name, index, css_class, className) {
  component = (
    <TextField
      source={source_name}
      key={index}
    />
  );
  return component;
}
function textFieldDisabled(component, source_name, index, css_class, className) {
  component = (
    <TextInput
      source={source_name}
      disabled
      key={index}
      className={`show-field ${css_class} ${className}`}
    />
  );
  return component;
}
function colorField(component, source_name, index, css_class, className) {
  component = (
    <ColorField
      source={source_name}
      key={index}
      className={`show-field ${css_class} ${className}`}
    />
  );
  return component;
}
function timeField(component, source_name, index, css_class, className) {
  component = (
    <TimeField
      source={source_name}
      key={index}
      className={`show-field ${css_class} ${className}`}
    />
  );
  return component;
}
function longTextInput(component, source_name, index, css_class, is_required, full_width) {
  component = (
    <TextInput
      multiline
      validate={is_required ? [required()] : undefined}
      fullWidth={full_width}
      source={source_name}
      key={index}
      className={` ${css_class}  `}
    />
  );
  return component;
}
function longTextField(component, source_name, index, css_class, full_width) {
  component = (
    <TextField
      fullWidth={full_width}
      source={source_name}
      key={index}
      className={` ${css_class}  `}
    />
  );
  return component;
}
function TranslatableTextInput(
  component,
  source_name,
  index,
  css_class,
  is_required
) {
  component = (
    <TranslatableInputs
      locales={["ar", "en"]}
      defaultLocale="ar"
      validate={is_required ? [required()] : undefined}
    >
      <TextInput source={source_name} />
    </TranslatableInputs>
  );
  return component;
}
function TranslatableTextSearch(
  component,
  source_name,
  index,
  css_class,
  is_required,
  locale
) {
  component = (<TextInput key={index}  source={`${source_name}.${locale}`} />);
  return component;
}
function TranslatableTextField(
  component,
  source_name,
  index,
  css_class,
  className,
  locale
) {
  component = (
    <TextField source={`${source_name}.${locale}`} />
  );
  return component;
}
